import { AbiRegistry } from '@multiversx/sdk-core/out';
import launchpadAbi from './abi/launchpad-sc.abi.json';
import farmAbi from './abi/onedex-farm-sc.abi.json';
import dexAbi from './abi/onedex-sc.abi.json';
import stakingAbi from './abi/onedex-staking-sc.abi.json';

export const DexAbi = AbiRegistry.create(dexAbi);
export const FarmAbi = AbiRegistry.create(farmAbi);
export const StakingAbi = AbiRegistry.create(stakingAbi);
export const LaunchpadAbi = AbiRegistry.create(launchpadAbi);


export const dAppName = 'OneDex';

// Generate your own WalletConnect 2 ProjectId here: https://cloud.walletconnect.com/app
export const walletConnectV2ProjectId = '38c2543f2334bde2031d4b78402e74ca';

export const apiTimeout = 6000;
export const transactionSize = 15;

export const farmCost = 2;
export const stakingCost = 2;

export const isDev = true;

export const contracts = {
  'Dex': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqkyelkntgpmya6qy5kgwzzcajwtc7f0xgkqys3ys6ys' : '',
    abi: DexAbi,
  },
  'Farm': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqjd36eczcww5jl2cjhjd35wcxkqgm405nkqys4xddrj' : '',
    abi: FarmAbi
  },
  'Staking': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqfhx6ep3hlrjzkwrdrzmgxldw9sm2guyqkqyserjg88' : '',
    abi: StakingAbi
  },
  'Launchpad': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgq4zqefr7j9qds79z2u734c6zrx5gfaxc85zvsj20hxw' : '',
    abi: LaunchpadAbi
  },
  'Wrap0': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqd77fnev2sthnczp2lnfx0y5jdycynjfhzzgq6p3rax' : ''
  },
  'Wrap1': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgq7ykazrzd905zvnlr88dpfw06677lxe9w0n4suz00uh' : ''
  },
  'Wrap2': {
    address: isDev ? 'erd1qqqqqqqqqqqqqpgqfj3z3k4vlq7dc2928rxez0uhhlq46s6p4mtqerlxhc' : ''
  }
};

export const ElrondApiUrl = isDev ? 'https://devnet-api.multiversx.com' : 'https://api.multiversx.com';


// launchpad
export const WEGLD_ID = isDev? 'WEGLD-d7c6bb' : '';
export const USDC_ID = isDev? 'USDC-8d4068' : '';
export const SOCIAL_WEBSITE_URL = 'https://';
export const LAUNCHPAD_CONFIG = {
  egld_token_identifier: 'EGLD',
  egld_token_decimal: 18,
  usdc_token_decimal: 6,
  pool_creation_fee: 2,
  fee_percent_fund_token: 2,
  min_percent_soft_cap: 50,
};
